import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import ThemeWrapper from '../ThemeWrapper ';
import Loader from './Loader';

const ListingStep7 = ({ formData, handleChange, prevStep, onRegisterSave }) => {
  const { listingId } = formData;
  const [listingData, setListingData] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [categoryId, setCategoryId] = useState('');
  const [question, setQuestion] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [nextLoading, setNextLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getAmenities}`,
          data: formData,
        });

        if (response.data.status === 'ama') {
          setAmenities(response.data.ama_list);
          setLoading(false);
        } else {
          setError('An error occurred while fetching data.');
        }
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    const fetchListingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);

      setLoading(true);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getListingData}`,
          data: formData,
        });

        if (response.data.status === 'ok') {
          const listingData = response.data.updated_property_item;
          const { appr_list, resrv_list, offers, place_options_list } = listingData;
          setListingData(response.data.updated_property_item);
          setQuestion(response.data.updated_property_item.questions);

          setCategoryId(response.data.updated_property_item.category_id);
          const selectedIds = response.data.updated_property_item.amanities.map((amenity) => amenity.ama_id);
          setSelectedAmenities(selectedIds);

          setLoading(false);
        } else {
          toast.error('An error occurred while fetching data.');
          setLoading(false);
        }
      } catch (err) {
        console.log(err.message);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
    fetchListingData();
  }, []);

  const saveListing = async () => {
    const hostData = getItemFromLocalStorage('hostProfile');
    const listing_id = listingId;
    const ts = Date.now();

    const mergedData = {
      ...listingData,
      amanities: selectedAmenities.map((ama_id) => ({
        ama_id,
        stay_listing_id: listingId,
      })),
    };

    let catData = new FormData();
    catData.append('token', hostData.host_access_token);
    catData.append('listing_id', listing_id);
    catData.append('data', JSON.stringify(mergedData));
    /*catData.append(
      'data',
      JSON.stringify({
        amanities: selectedAmenities.map((ama_id) => ({ ama_id, stay_listing_id: listingId })),
      })
    );*/
    catData.append('ts', ts);

    setNextLoading(true);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        url: `${params.baseURL}${params.endpoints.updateListing}`,
        data: catData,
      });

      if (response.data.status === 'done') {
        return true;
      } else {
        toast.error('Failed to save data');
        return false;
      }
    } catch (err) {
      toast.error('An error occurred while saving the listing');
      return false;
    }
  };



  const handleAmenityChange = (e) => {
    const { value } = e.target;
    if (selectedAmenities.includes(parseInt(value))) {
      setSelectedAmenities(selectedAmenities.filter((id) => id !== parseInt(value)));
    } else {
      setSelectedAmenities([...selectedAmenities, parseInt(value)]);
    }
  };

  const renderCategory = (id, title, list) => (
    <div className='gss-box' key={title}>
      <div className='gss-txt-img-box'>
        {/*<img src={`/assets/img/icons/amanity_${id}.svg`} alt='' className='gss-img' />*/}
        <h4 className='m-0'>{title}</h4>
      </div>
      <div className='cat-box'>
        {list.length > 0 ? (
          list.map((item) => (
            <label className='cat-label' key={item.ama_id}>
              <input
                type="checkbox"
                value={item.ama_id}
                checked={selectedAmenities.includes(item.ama_id)}
                onChange={handleAmenityChange}
              />
              <span>
                <img
                  src={
                    item.ama_image
                      ? item.ama_image_url
                      : 'https://stcontent.blr1.digitaloceanspaces.com/stays/1722843850_stct.png'
                  }
                  alt={item.ama_name ? item.ama_name : 'Untitled Listing'}
                  className='cat-img'
                />
                <p>{item.ama_name}</p>
              </span>
            </label>
          ))
        ) : (
          <p>No items found in {title}</p>
        )}
      </div>
    </div>
  );

  const faqs = [
    {
      question: "What is Lorem Ipsum?",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
      question: "Where does it come from?",
      answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <ThemeWrapper categoryId={categoryId}>
      <button id='host-listing-trigger-7' style={{ display: 'none' }} onClick={() => {
        if (onRegisterSave) {
          onRegisterSave(saveListing);
        }
      }}>Done</button>
      <div className="fade-in">
        <div className='row'>
          {/*<div className='col-md-4 listing-img-box'>
            <div className='lsib'>
              <img src={'/assets/img/listing/listing_side_img.gif'} alt="Listing Image" className="listing-image" />
              {question && (
                <div className='lsqa-btn'>
                  <StarButton text="Guide" link={question.find((q) => q.id === 7)?.link || '#'} />
                </div>
              )}
            </div>
          </div>*/}

          <div className='col-md-8'>

            <div className='ws-cl-header'>
              <div>
                <h4 className='ws-title'>Highlight What Your Space Offers ?</h4>
              </div>
            </div>

            {loading ? <p>Loading...</p> : null}
            {error ? <p>{error}</p> : null}

            <div className='st1-desc-box'>
              {amenities.length > 0 ? (
                <>
                  {renderCategory(1, 'General', amenities[0].list)}
                  {renderCategory(2, 'Do you have any standout amenities?', amenities[2].list)}
                  {renderCategory(3, 'Do you have any of these safety items?', amenities[4].list)}
                </>
              ) : (
                <p>No data found</p>
              )}
            </div>

          </div>

          <div className='col-md-4 p-0'>
            <div className='bfhsd'>
              <div className='blog-box'>
                <div class="blog">
                  <div class="blog-image">
                    <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                    <div class="date">May 08, 2025</div>
                  </div>
                  <div class="blog-content">
                    <h2>What is Lorem Ipsum?</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                    <a href="#">Read More</a>
                  </div>
                </div>
              </div>
              <div className="faq-sticky">
                {faqs.map((faq, index) => (
                  <div key={index} className='faqs-list-section'>
                    <div
                      onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                      style={{
                        backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                      }}
                    >
                      {faq.question}
                      <i
                        className={`fas ${activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                          }`}
                        style={{
                          transition: "transform 0.3s ease",
                        }}
                      ></i>
                    </div>
                    {activeIndex === index && (
                      <div className='faqs-ans-box'>
                        {faq.answer}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </ThemeWrapper>
  );
};

export default ListingStep7;
